import axios from 'axios';
import { SERVER_API_URL } from '../../config/envConf';

export interface Login {
    username: string;
    password: string;
}

export interface Register {
    username: string,
    password: string,
    confirmPassword: string,
    firstname: string,
    lastname: string,
    position: string,
    companyName: string,
    address: {
        streetAddress: string,
        zipCode: string,
        state: string,
        city: string,
    },
    phoneNumber: string,
    role: number,
}

export interface ForgotPassword {
    username: string;
}

export interface UpdatePassword {
    password: string,
    token: string;
}

const postLogin = (data: Login) => {
  const url = `${SERVER_API_URL}authenticate`;
  return axios.post(url, data);
};

const postRegister = (data: Register) => {
  const url = `${SERVER_API_URL}registration`;
  return axios.post(url, data);
};

const postForgotPassword = (data: ForgotPassword) => {
  const url = `${SERVER_API_URL}forgot-pass`;
  return axios.post(url, data);
};

const postUpdatePassword = (data: UpdatePassword) => {
  const url = `${SERVER_API_URL}update-pass`;
  return axios.post(url, data);
};

const auth = {
  postLogin, postRegister, postForgotPassword, postUpdatePassword,
};

export default auth;
